export const supportWidgetLanguage = {
  support: 'پشتیبانی',
  createTicket: 'ثبت تیکت جدید',
  send: 'ارسال',
  title: 'عنوان',
  submitFeedback: 'ثبت بازخورد',
};
